import styled from 'styled-components';
import media from 'src/styles/Media.styled';

export const MobileHeader = styled.div`
    display: none;
    ${media.mobileDevice`
    width: auto;
    height: 74px;
    display: flex;
    justify-content: space-between;
    margin-top: -70px;
        background: #140F4B;
    `}
`;

export const Heading = styled.span`
    text-align: right;
    font-family: ${({ isRegular, isDemi, isItalic }) =>
        isRegular
            ? 'AvenirNextWorld Regular'
            : isDemi
            ? 'AvenirNextWorld Demi'
            : isItalic && 'AvenirNextWorld italic'};
    font-size: ${({ isDemi }) => (isDemi ? '12px' : '12px')};
    color: ${({ isRegular, isDemi }) =>
        isRegular ? '#140F4B' : isDemi && '#140F4B'};
    ${media.mobileDevice`
    text-align: left;
        font-size: ${({ isDemi }) => (isDemi ? '12px' : '12px')};
        color: ${({ isRegular, isDemi }) =>
            isRegular ? '#140F4B' : isDemi && '#140F4B'};
    `}
`;

export const Title = styled.div`
    font-family: 'AvenirNextWorld Demi';
    font-size: 24px;
    color: #140f4b;
    letter-spacing: 0px;
    opacity: 1;
    text-align: center;
    ${media.mediumDevice`
        color: #140f4b;
        text-align: left;
    `}
    ${media.smalDevice`
        color: #140f4b;
    `}
    ${media.mobileDevice`    
    font-family: 'AvenirNextWorld Demi';
    color: #FFFFFF;
    font-size: 22px;
    text-align: left;
    letter-spacing: 0px;
    margin: auto;
    `}
`;

export const DesktopSubHeader = styled.div`
    display: flex;
    justify-content: center;
    margin: auto;
    background: #f5f5f5;
    padding: 10px 0px;
    opacity: 1;
    // z-index: 999;
    ${media.mobileDevice`
    display: none;
    `}
`;

export const DesktopHeader = styled.div`
    display: flex;
    justify-content: space-between;
    background: #f5f5f5;
    align-items: center;
    ${media.mobileDevice`
    display: none;
    `}
`;
